module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDgxOUIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuMzI2IDIuNDlsMy4wNSAzLjA1MS03LjcyMiA3LjcyMy0zLjA0OS0zLjA1MSA3LjcyLTcuNzIyem01LjM2NS0uNzM1bC0xLjM2LTEuMzZhMS4zNSAxLjM1IDAgMCAwLTEuOTA3IDBMMTAuMTIgMS42OTdsMy4wNTEgMy4wNSAxLjUyLTEuNTJhMS4wNCAxLjA0IDAgMCAwIDAtMS40NzN6TS4wMDggMTQuNWMtLjA1NS4yNS4xNy40NzQuNDIuNDEzbDMuNC0uODI0LTMuMDQ5LTMuMDUxLS43NyAzLjQ2MnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./components/atoms/Icon/icons/pencil-edit-button-1_2.svg
// module id = 1737
// module chunks = 0